import React from 'react';
import { Calendar, MapPin, Users, User, Phone, IdentificationCard, Lightning } from '@phosphor-icons/react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const InfoRow = ({ icon: Icon, label, value, extra }) => (
  <div className="flex items-start gap-3">
    <Icon size={20} weight="bold" className="text-[#C1121F] mt-0.5" />
    <div>
      <p className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] mb-1">{label}</p>
      {value}
      {extra}
    </div>
  </div>
);

export const MovilizacionInfoGrid = ({ movilizacion }) => (
  <>
    {movilizacion.es_emergente && (
      <div
        data-testid="emergente-badge"
        className="mb-3 flex items-start gap-3 p-3 bg-[#C1121F]/10 border border-[#C1121F]"
      >
        <Lightning size={18} weight="fill" className="text-[#C1121F] mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-[#C1121F] font-['IBM_Plex_Sans'] mb-1">
            Movilización Emergente
          </p>
          {movilizacion.justificacion && (
            <p className="text-sm text-[#0A0A0A] font-['IBM_Plex_Sans']">
              <span className="font-medium">Justificación: </span>{movilizacion.justificacion}
            </p>
          )}
        </div>
      </div>
    )}
    <div className="grid md:grid-cols-2 gap-4">
    <div className="space-y-3">
      <InfoRow
        icon={Calendar}
        label="Fecha y Hora"
        value={
          <>
            <p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">
              {format(new Date(movilizacion.fecha_inicio), "d MMM yyyy, HH:mm", { locale: es })} -
            </p>
            <p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">
              {format(new Date(movilizacion.fecha_fin), "d MMM yyyy, HH:mm", { locale: es })}
            </p>
          </>
        }
      />
      <InfoRow
        icon={MapPin}
        label="Sitio de Salida"
        value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.direccion}</p>}
        extra={<p className="text-xs text-[#495057] font-['IBM_Plex_Sans'] mt-1">Ref: {movilizacion.referencia}</p>}
      />
      {movilizacion.direccion_llegada && (
        <InfoRow
          icon={MapPin}
          label="Lugar de Llegada"
          value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.direccion_llegada}</p>}
        />
      )}
      <InfoRow
        icon={Users}
        label="Personas"
        value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.num_personas}</p>}
      />
    </div>
    <div className="space-y-3">
      <InfoRow
        icon={User}
        label="Responsable"
        value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.responsable}</p>}
      />
      <InfoRow
        icon={Phone}
        label="Contacto"
        value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.telefono_contacto}</p>}
      />
      <InfoRow
        icon={IdentificationCard}
        label="Área"
        value={<p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{movilizacion.area}</p>}
      />
    </div>
  </div>
  {movilizacion.materiales && (
    <div data-testid="materiales-block" className="mt-4 pt-4 border-t border-[#E9ECEF]">
      <p className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] mb-1 uppercase tracking-wide font-bold">
        Materiales a Transportar
      </p>
      <p className="text-sm font-['IBM_Plex_Sans'] text-[#0A0A0A] whitespace-pre-line">
        {movilizacion.materiales}
      </p>
    </div>
  )}
  {!movilizacion.es_emergente && movilizacion.motivo && (
    <div data-testid="motivo-block" className="mt-4 pt-4 border-t border-[#E9ECEF]">
      <p className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] mb-1 uppercase tracking-wide font-bold">
        Motivo de la Movilización
      </p>
      <p className="text-sm font-['IBM_Plex_Sans'] text-[#0A0A0A] whitespace-pre-line">
        {movilizacion.motivo}
      </p>
    </div>
  )}
  </>
);
